import { makeStyles, createStyles } from "@material-ui/core";
import { customTheme } from "../../utils/ThemeConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "fixed",
      zIndex: 89,
      width: `calc(100% - ${theme.spacing(9) + 10}px)`,
      height: customTheme.mixins.tabbar.height,
      minHeight: customTheme.mixins.tabbar.minHeight,
      backgroundColor: "#E8E8E8",
      "& .Mui-selected": {
        backgroundColor: theme.palette.background.default,
        borderRadius: "12px 12px 0px 0px",
      },
      "& .MuiTabs-indicator": {
        opacity: 0,
      },
      "& .MuiTabScrollButton-root.Mui-disabled": {
        opacity: 0.8,
        color: "#7d7c7c",
      },
    },
    rootMobile: {
      position: "fixed",
      zIndex: 89,
      width: `calc(100% - ${theme.spacing(9) + 10}px)`,
      height: customTheme.mixins.tabbar.heightMobile,
      minHeight: customTheme.mixins.tabbar.minHeightMobile,
      backgroundColor: "#E8E8E8",
      "& .Mui-selected": {
        backgroundColor: theme.palette.background.default,
        borderRadius: "12px 12px 0px 0px",
      },
      "& .MuiTabs-indicator": {
        opacity: 0,
      },
      "& .MuiTabScrollButton-root.Mui-disabled": {
        opacity: 0.8,
        color: "#7d7c7c",
      },
    },
    mobile: {
      width: "100%",
    },
    tabRoot: {
      height: customTheme.mixins.tabbar.height,
      minHeight: customTheme.mixins.tabbar.minHeight,
      minWidth: "auto",
      "& .MuiTab-wrapper": {
        flexDirection: "row",
      },
    },
    tabRootMobile: {
      height: customTheme.mixins.tabbar.heightMobile,
      minHeight: customTheme.mixins.tabbar.minHeightMobile,
      minWidth: "auto",
    },
    tab: {
      height: customTheme.mixins.tabbar.height,
      minWidth: 250,
      maxWidth: 250,
      minHeight: customTheme.mixins.tabbar.minHeight,
      "& .MuiTab-wrapper": {
        height: "100%",
        flexDirection: "row",
        justifyContent: "flex-start",
      },
    },
    tabMobile: {
      height: customTheme.mixins.tabbar.heightMobile,
      minHeight: customTheme.mixins.tabbar.minHeightMobile,
      minWidth: 120,
      maxWidth: 120,
    },
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginBottom: "0px !important",
      marginRight: 5,
    },
    avatarMobile: {
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      fontSize: "x-small",
    },
    entry: {
      border: `3px solid ${theme.palette.primary.main}`,
    },
    exit: {
      border: `3px solid ${theme.palette.warning.light}`,
    },
  })
);

export default useStyles;
